<div class="donors">
  <img loading="lazy" [attr.data-src]="supporterImg">
  <span><strong>{{subsCount?.monthlyDonors | inrFormat:'INR'}}</strong> donors are giving monthly</span>
</div>